module.exports = __webpack_public_path__ + "media/images/butterfly-b54f9d9376a1c4694c0fe24f7f1e38af.jpeg";